import React, { useState } from 'react';

const JSONKeyValueExtractor = () => {
    const [jsonInput, setJsonInput] = useState('');
    const [keyValuePairs, setKeyValuePairs] = useState([]);
    const [error, setError] = useState('');
    const [copySuccess, setCopySuccess] = useState(false);

    const exampleJSON = `{
        "name": "Alice",
        "age": 30,
        "address": {
            "city": "New York",
            "zip": "10001"
        },
        "skills": ["JavaScript", "React"]
    }`;

    const extractKeyValues = () => {
        try {
            const parsedJSON = JSON.parse(jsonInput);
            const pairs = extractPairs(parsedJSON);
            setKeyValuePairs(pairs);
            setError('');
            setCopySuccess(false);
        } catch (err) {
            setError('Invalid JSON. Please check your input.');
            setKeyValuePairs([]);
            setCopySuccess(false);
        }
    };

    const extractPairs = (obj, prefix = '') => {
        const pairs = [];
        for (const key in obj) {
            const fullKey = prefix ? `${prefix}.${key}` : key;
            if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                pairs.push(...extractPairs(obj[key], fullKey));
            } else {
                pairs.push({ key: fullKey, value: obj[key] });
            }
        }
        return pairs;
    };

    const clearInputs = () => {
        setJsonInput('');
        setKeyValuePairs([]);
        setError('');
        setCopySuccess(false);
    };

    const useExampleData = () => {
        setJsonInput(exampleJSON);
        setKeyValuePairs([]);
        setError('');
        setCopySuccess(false);
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(
            keyValuePairs.map(pair => `${pair.key}: ${pair.value}`).join('\n')
        );
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
    };

    return (
        <div className="container mt-4">
            <div className="text-center mb-3">
                <button className="btn btn-info" onClick={useExampleData}>
                    Use Example Data
                </button>
            </div>
            <div className="mb-3">
                <textarea
                    className="form-control"
                    rows="10"
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                    placeholder="Enter JSON object here..."
                    style={{
                        border: '2px solid #ccc',
                        borderRadius: '5px',
                    }}
                />
            </div>
            <div className="text-center">
                <button className="btn btn-success me-2" onClick={extractKeyValues}>
                    Extract Key-Value Pairs
                </button>
                <button className="btn btn-secondary" onClick={clearInputs}>
                    Clear
                </button>
            </div>
            {error && <div className="alert alert-danger text-center mt-3">{error}</div>}
            {keyValuePairs.length > 0 && (
                <div className="mt-4">
                    <h5>Extracted Key-Value Pairs</h5>
                    <table className="table table-bordered">
                        <thead className="table-light">
                            <tr>
                                <th>Key</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {keyValuePairs.map((pair, index) => (
                                <tr key={index}>
                                    <td>{pair.key}</td>
                                    <td>{typeof pair.value === 'object' ? JSON.stringify(pair.value) : pair.value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="text-center mt-2">
                        <button
                            className={`btn ${copySuccess ? 'btn-success' : 'btn-primary'}`}
                            onClick={handleCopy}
                        >
                            {copySuccess ? 'Copied!' : 'Copy Pairs'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default JSONKeyValueExtractor;